import styled from "styled-components";
import { hoverStyle, focusStyle } from "@mixins";
export var ColorSelect = styled.button.withConfig({
  displayName: "selectColorDialogstyles__ColorSelect",
  componentId: "sc-1enxbdr-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme,
    color = _ref.color;
  return "\n    background: ".concat(color || theme.colors.P3, ";\n    width: 44px;\n    height: 44px;\n    margin: 0 12px 20px 0;\n    transition: all .3s;\n\n    &:focus{ ").concat(focusStyle(theme), " }\n    &:hover{ ").concat(hoverStyle(theme), " }\n");
});